var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLanguage({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "language",
    clipPath: "url(#clip0_41518_7214)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9275 9.42417C13.8052 3.83098 11.9195 -0.0185547 10.224 -0.0185547C8.5285 -0.0185547 6.64274 3.83132 6.52053 9.42417H13.9275ZM7.79712 19.719C3.62027 18.678 0.473986 15.0079 0.222656 10.5755H5.37027C5.45537 14.5449 6.40084 17.9052 7.79712 19.719ZM10.224 20.0183C8.5285 20.0183 6.64287 16.1687 6.52053 10.5755H13.9275C13.8053 16.1684 11.9195 20.0183 10.224 20.0183ZM0.225399 9.4238C0.476633 4.9918 3.62285 1.32154 7.79987 0.280315C6.40092 2.09546 5.45409 5.45444 5.37297 9.4238H0.225399ZM12.6482 19.7194C16.8252 18.6781 19.9714 15.0079 20.2227 10.5759H15.0751C14.994 14.5452 14.0471 17.9042 12.6482 19.7194ZM15.075 9.4238C14.9899 5.45444 14.0445 2.09414 12.6482 0.280315C16.825 1.3227 19.9739 4.99146 20.2226 9.4238H15.075Z",
    fill: "#002466"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_41518_7214"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.222656)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguage);
export default __webpack_public_path__ + "static/media/language.62c7c470e3a9f5c1f0befba69befcbb1.svg";
export { ForwardRef as ReactComponent };